export const policyTypeArray = [
  {
    id: "Partial",
    category: "BEFORE_CHECKIN",
    percentage: 0.5,
    validFrom: 0,
    validTo: 7,
    description:
      "Guests can cancel 7 or more days before check-in for a 50% refund, minus the cancellation fee.",
    hostPolicyDescription:
      "Host receives 50% payout if guest cancels 7 or more days before check-in.||Host receives 100% of payout if guest cancels fewer than 7 days before check-in.",
    hostPolicyPercentage: 0.5,
  },
  {
    id: "Standard",
    category: "BEFORE_CHECKIN",
    percentage: 1,
    validFrom: 0,
    validTo: 14,
    description:
      "Guests can cancel 14 or more days before check-in for a full refund, minus the cancellation fee.",
    hostPolicyDescription:
      "Host receives no payout if guest cancels 14 or more days before check-in.||Host receives 100% of payout if guest cancels fewer than 14 days before check-in.",
    hostPolicyPercentage: 1,
  },
  {
    id: "Moderate",
    category: "BEFORE_CHECKIN",
    percentage: 1,
    validFrom: 0,
    validTo: 30,
    description:
      "Guests can cancel 30 or more days before check-in for a full refund, minus the cancellation fee.",
    hostPolicyDescription:
      "Host receives no payout if guest cancels 30 or more days before check-in.||Host receives 100% of payout if guest cancels fewer than 30 days before check-in.",
    hostPolicyPercentage: 1,
  },
  {
    id: "Strict",
    category: "BEFORE_CHECKIN",
    percentage: 1,
    validFrom: 0,
    validTo: 60,
    description:
      "Guests can cancel 60 or more days before check-in for a full refund, minus the cancellation fee.",
    hostPolicyDescription:
      "Host receives no payout if guest cancels 60 or more days before check-in.||Host receives 100% of payout if guest cancels fewer than 60 days before check-in.",
    hostPolicyPercentage: 1,
  },
]
